// Static product configuration for the SAA Woonhuis wire documents. Mirrors the
// doorlopendereis/fields.ts shape. Only the request/enrich-path PP defaults live here
// so far; the whale screen's remaining inline values migrate here as it gets decomposed.

// Schema defaults both wire touchpoints (summary/enrich.ts and ConfirmationScreen)
// must agree on, applied there via applyPpDefaults instead of duplicated literals.
export const WOONHUIS_PP_REQUEST_DEFAULTS: Record<string, string | number> = {
  PP_CDUUMND: 12,
};
